<script lang="ts" setup>
import PermissionLock from '../../PermissionLock.vue';
import { VChip } from 'vuetify/lib/components/index.mjs';
import { useLocale } from '../../../composables/useLocale';

const { t } = useLocale();

defineProps<{
  permissionError?: string | false;
  userName: string;
  to?: string;
}>();

const emit = defineEmits<{
  (e: 'delete'): void;
  (e: 'gotoUser'): void;
}>();
</script>

<template>
  <v-chip style="min-width: 100px" :to="to" link>
    <template #prepend>
      <v-icon :aria-label="`${t('lcp.go_to_user_profile')} ${userName}`" @click="emit('gotoUser')" color="primary">
        mdi-account
      </v-icon>
    </template>
    <span
      tabindex="0"
      role="button"
      @click="emit('gotoUser')"
      @keydown.enter="emit('gotoUser')"
      style="cursor: pointer"
    >
      {{ userName }}
    </span>
    <template #append>
      <v-icon
        v-if="!permissionError"
        color="primary"
        :aria-label="`${t('lcp.remove')} ${userName}`"
        @click="() => emit('delete')"
      >
        mdi-window-close
      </v-icon>
      <PermissionLock v-else :reason="permissionError || undefined" color="primary" />
    </template>
  </v-chip>
</template>
